export default "__VITE_ASSET__CpxSfYG8__"